import { Typography, List, ListItem } from "@mui/material";
const date = new Date();
const language = window?.navigator?.language || "en";

export const EULA = (
  <Typography>
    This Software License Agreement is an End User License Agreement
    (“EULA/Agreement”):
    <br />
    <br />
    <Typography sx={{ fontWeight: "bold" }}>ACKNOWLEDGMENT</Typography>
    <br />
    By clicking the "I Agree" button, downloading or using the Molecule Gen
    (hereinafter referred to as “Software”), you are agreeing to be bound by the
    terms and conditions of this Agreement. If you do not agree to the terms of
    this Agreement, do not click on the "I Agree" button, do not download or do
    not use the Software.
    <br />
    By using the Software, you represent that you:
    <List>
      <ListItem>(1) have read and understood the terms;</ListItem>
      <ListItem>
        (2) agree to use the Software in compliance with this EULA, all
        applicable local, state, national, and international laws and
        regulations, and the rules or policies of your Institution; and
      </ListItem>
      <ListItem>
        (3) are an Authorized User. You may not use the Software if you do not
        agree with the EULA or if you are not an Authorized User.
      </ListItem>
    </List>
    This Agreement is a legal document that governs your use of the Software,
    which is licensed, not sold, to you by the Licensor strictly in accordance
    with this Agreement.
    <br />
    <br />
    MOLECULE AI PRIVATE LIMITED, (CIN: U62099DL2023PTC410841) with their
    registered office at 31, Vaishali, Ground Floor, Pitampura, Saraswati Vihar,
    North West Delhi, Delhi, Delhi, India – 110034 (hereinafter referred to as
    “Licensor/Company”) has developed and owns the software/platform
    (hereinafter referred to as “Software") used for the purpose of Drug
    Discovery Using AI ; “Software" shall mean a computer program(s) in machine
    readable form, whereby intellectual property rights are owned by the
    Licensor. Software includes any updates, upgrades, modifications,
    enhancements, configurations and customizations of source code, binary code,
    user interface, libraries, data integration patterns, data structures,
    automation patterns, and all related designs and documentations.
    <br />
    <br />
    The “EULA/Agreement” shall mean this End User License Agreement that shall
    further include the recitals, schedules, annexures or exhibits annexed.
    <br />
    <br />
    For the purposes of this Agreement, “Intellectual Property Rights” shall
    mean all present and future rights conferred by statute, common law, or
    equity in or in relation to patents, trademarks, service marks, trade names,
    domain names, copyright (including rights in software), database rights,
    source code, binary code, user interface, libraries, data structures,
    automation patterns, computer programs, design rights, trade secrets,
    know-how, confidential information, and any other intellectual property
    rights, whether registered or unregistered, including all applications,
    renewals, extensions, and revivals thereof, in any part of the world.
    <br />
    <br />
    Additionally, “End User or You” shall mean the person using the Software for
    the permitted use hereunder.WHEREAS, End-User is desirous of using the
    Software for its internal business purposes which shall be subject to the
    Terms & Conditions laid down in this Agreement.
    <br />
    <br />
    Now, therefore, in consideration of the premises representations contained
    herein, the End User hereto do agree as follows:
    <br />
    <br />
    <List
      sx={{
        listStyleType: "decimal",
        listStylePosition: "inside",
      }}
    >
      <ListItem sx={{ display: "list-item" }}>
        That subject to the terms and conditions of this Agreement, the Licensor
        grants to the End-User a non-exclusive, non-transferable,
        non-assignable, non-sub-licensable, term based, fee based, revocable
        (upon breach of this Agreement), limited license rights to access and
        use the Software for the purposes defined in the terms of this
        Agreement.
      </ListItem>
      <ListItem sx={{ display: "list-item" }}>
        That the End-User hereby accepts a limited, non-transferable,
        non-exclusive license to use the Software within India for a duration as
        licensed under the terms of this EULA wherein initial fifteen (15) Days
        are subject to trial basis which may extend on payment of Licensing Fees
        as prescribed by the Company. The End User shall make a request for an
        extension in writing to the Company, subject to the Licensor’s consent
        and applicable fees.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        That notwithstanding anything to the contrary, the Licensor retains all
        rights, title, and interest in and to the Software. The End-User
        acknowledges that this Agreement does not convey any ownership rights in
        the Software.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        Licensor warrants that it has the right to provide the Software to
        End-User hereunder. However, Licensor provides the Software to End-User
        “as is.” Licensor makes no warranties or representations that the
        Software is free of errors or defects, or that it adequately performs
        the functions it is intended to perform.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        In relation with the usage of the Software by the End-User, End-User
        acknowledges, represents and warrants that:
        <List>
          <ListItem>
            (i) Licensor owns and retains all Intellectual Property Rights
            necessary to produce customizations, updates and/or corrections to
            the Software;
          </ListItem>
          <ListItem>
            (ii) End-User shall not copy, modify, replicate, clone or create
            derivative works of the Software. End-User will not distribute,
            sublicense, lease, rent, or otherwise transfer the Software to any
            third party.
          </ListItem>
          <ListItem>
            (iii) End-User shall not use the Software for any illegal,
            unauthorized, or unethical purpose.
          </ListItem>
          <ListItem>
            (iv) End-User does not infringe the Intellectual Property Rights of
            the Licensor; and
          </ListItem>
        </List>
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        For the purposes of this Agreement, “Confidential Information” shall
        mean and include this Agreement and all its Schedules, any addenda
        hereto signed by both the Parties, any information disclosed by the
        Licensor to the End-User that is written, graphic, machine readable or
        other information that can be construed as confidential/proprietary by
        way of usage or in some other manner to indicate its confidential
        nature, all Software listings, documentation, information, drawings,
        benchmark tests, specifications, trade secrets, source code, binary
        code, database records, user interface, libraries, data structures,
        automation patterns, computer programs and machine-readable copies of
        the Software, and any other proprietary information supplied to the
        End-User.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        End-User shall treat the Software, and customizations, updates and/or
        corrections, if any, as confidential, and shall protect it in the same
        manner that it protects the confidentiality of its own information.
        Notwithstanding any other rights of termination set out elsewhere in
        this Agreement, the Licensor shall have the right to terminate this
        Agreement immediately without giving notice by registered mail of such
        termination in the event End-User commits a material breach of any of
        its obligations hereunder.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        End-User shall implement and maintain reasonable administrative and
        technical safeguards to protect any data processed through the Software
        against unauthorized access, use, disclosure, or destruction. End-User
        shall ensure the following:
        <List>
          <ListItem>
            (a) Ensure that any data input into the Software complies with
            applicable data protection laws.
          </ListItem>
          <ListItem>
            (b) Use appropriate security measures to prevent unauthorized access
            to the Software.
          </ListItem>
          <ListItem>
            (c) Notify Licensor immediately in the event of any suspected
            security breach. Licensor does not assume responsibility for the
            long-term storage of any data processed through the Software.
            End-User shall maintain backups of critical data outside of the
            Software.
          </ListItem>
        </List>
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        The Licensor reserves the right to terminate this Agreement immediately
        without notice if the End-User:
        <List>
          <ListItem>
            (a) Violates any material provision of this Agreement.
          </ListItem>
          <ListItem>
            (b) Attempts to reverse-engineer, decompile, or tamper with the
            Software.
          </ListItem>
          <ListItem>
            (c) Fails to comply with data security obligations.
          </ListItem>
        </List>
        <ListItem>
          In the event of default of the Terms and Conditions within this
          Agreement:
        </ListItem>
        <List sx={{ pl: 4 }}>
          <ListItem>
            (a) End-User shall immediately cease all use of the Software.
          </ListItem>
          <ListItem>
            (b) End-User shall delete or destroy any copies of the Software in
            its possession.
          </ListItem>
          <ListItem>
            (c) Licensor may pursue legal remedies for damages resulting from
            End-User's breach.
          </ListItem>
        </List>
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        End-User agrees to indemnify and hold Licensor harmless from and against
        all loss, cost, expense or liability (including reasonable attorney’s
        fees) arising out of a claim by a third party against Licensor based
        upon End-User’s use of the Software or is associated with usage of the
        Software by the End-User.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        Neither this Agreement nor any rights under this Agreement may be
        assigned or otherwise transferred by End-User, in whole or in part,
        whether voluntary or by operation of law, including by way of sale of
        assets, merger or consolidation, without the prior written consent of
        Licensor.
      </ListItem>

      <ListItem sx={{ display: "list-item" }}>
        This Agreement and the rights and obligations thereunder shall be
        governed by and construed in accordance with the laws of India and the
        courts of New Delhi.
      </ListItem>
    </List>
  </Typography>
);
